export const tl_data = {
    "beef" : {
        "en": "beef",
        "fr": "bœuf"
    },
    "chicken": {
        "en": "chicken",
        "fr": "poulet",
    },
    "eggs": {
        "en": "eggs",
        "fr": "œufs",
    },
    "pork": {
        "en": "pork",
        "fr": "porc",
    },
    "beyond-meat": {
        "en": "Beyond meat†",
        "fr": "Beyond Meat†",
    },
    "root-beer": {
        "en": "Rootbeer",
        "fr": "Rootbeer",
    },
    "coffee": {
        "en": "coffee",
        "fr": "Café",
    },
    "tomatoes": {
        "en": "Tomatoes",
        "fr": "Tomates",
    },
    "onions": {
        "en": "Onions",
        "fr": "Oignons",
    },
    "lettuce": {
        "en": "Lettuce",
        "fr": "Laitue",
    },
    "cheese": {
        "en": "Cheese",
        "fr": "Fromage",
    }
}